import { GroupRoutinesServices } from '../../services/grouproutines.service';
import { GroupRoutineType } from '../../types/grouproutines.type';
import ListComponent from '../common/ListComponent';

export function GroupRoutineList({ phase }: { phase: GroupRoutineType['phase'] }) {
    return (
        <ListComponent
            title={phase == 'warmup' ? "Warm Ups" : "Group Routines"}
            getAll={phase == 'warmup' ? GroupRoutinesServices.getAllWarmups
                : GroupRoutinesServices.getAllWorkoutRoutines}
            deleteById={GroupRoutinesServices.deleteById}
            columns={
                [
                    {
                        field: 'name',
                        headerName: 'Name',
                        flex: 1
                    },
                    {
                        field: 'exercises_duration',
                        headerName: 'Exercises Duration',
                        flex: 0.5
                    },
                    {
                        field: 'exercises_count',
                        headerName: '# Exercises',
                        flex: 0.5
                    }
                ]
            }

        />
    );
};